import Lines from "../../components/Lines";
import "./AboutUsDynamicPage.scss";

const AboutUsDynamicPage = ({ title, content }) => {
  return (
    <section className="aboutUsDynamicPageMainContainer">
      <header>
        <h2>{title}</h2>
        <div style={{ display: "flex" }}>
          <span className="linesParent">
            <Lines color="#0D553A" count={25} fontSize={2.3} spacing={0.5} />
          </span>
        </div>
      </header>
      <article>
        <p>{content}</p>
      </article>
    </section>
  );
};

export default AboutUsDynamicPage;
